var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { MessageBar, MessageBarType, } from "@fluentui/react";
import SpinnerOverlay from "./SpinnerOverlay";
import { WorkbenchService } from "../service/WorkbenchService";
import { ConfirmationDialog, RetryButton, SuccessMessage, ErrorMessage, } from "./WorkbenchDialogs";
import DebugService from "../service/DebugService";
import OfficeModeService from "../service/OfficeModeService";
import { checkDuplicateSubmission } from "../utils/duplicateDetection";
import { submitPlacement } from "../utils/placementSubmission";
import FileValidationService from "../service/FileValidationService";
import LandingSection from "./LandingSection";
import BUProductsSection from "./BUProductsSection";
import WorkbenchHeader from "./WorkbenchHeader";
import { useEnabledProducts } from "../hooks/useFeatureFlag";
const dropdownStyles = {
    dropdown: {
        width: "100%",
        boxShadow: "0 0px 4px rgba(0, 0, 0, 0.2)",
        borderRadius: 4,
        backgroundColor: "transparent",
        borderBottom: "3px #242424",
    },
};
const optionsBU = [
    { key: "MRSNA", text: "MRSNA" },
    { key: "MRSGM", text: "MRSGM" },
];
const optionsProducts = [
    { key: "20001", text: "Cyber" },
    { key: "10013", text: "NA LPL" },
    { key: "10012", text: "NA MPL" },
    { key: "20002", text: "Financial Lines" },
    { key: "10022", text: "Commercial General Liability" }
];
const optionsLOB = [
    { key: "106000", text: "Cyber" },
    { key: "104000", text: "Professional Liability" },
    { key: "101000", text: "Property" },
    { key: "110000", text: "Casualty" }
];
const optionsSubLOB = [
    { key: "106203", text: "Cyber", parentKey: "106000" },
    { key: "104202", text: "Miscellaneous Professional Liability", parentKey: "104000" },
    { key: "104205", text: "Lawyers Professional Liability", parentKey: "104000" },
    { key: "101202", text: "Commercial Lines Property", parentKey: "101000" },
    { key: "110201", text: "Financial Lines Financial Institutions", parentKey: "110000" },
    { key: "110202", text: "Financial Lines Commercial", parentKey: "110000" },
    { key: "110203", text: "Financial Lines Transactional Liability", parentKey: "110000" },
];
const addIcon = { iconName: "Add" };
const backIcon = { iconName: "Back" };
const WorkbenchLanding = ({ apiToken, graphToken, }) => {
    const workbenchService = WorkbenchService.getInstance();
    const enabledProductKeys = useEnabledProducts();
    const filteredProducts = optionsProducts.filter((product) => enabledProductKeys.includes(product.key));
    // State
    const [showLanding, setShowLanding] = useState(true);
    const [showBUProducts, setShowBUProducts] = useState(false);
    //const [selectedProduct, setSelectedProduct] = useState("20001");
    const [selectedLOB, setSelectedLOB] = useState(""); // Cyber
    const [selectedSubLOB, setSelectedSubLOB] = useState(""); //Cyber
    const [selectedBU, setSelectedBU] = useState("MRSGM");
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showFailureMessage, setShowFailureMessage] = useState(false);
    const [showLoadingMessage, setShowLoadingMessage] = useState(false);
    const [sendCopyToCyberAdmin, setSendCopyToCyberAdmin] = useState(false);
    const [assignIngestionToSelf, setAssignIngestionToSelf] = useState(false);
    const [forwardingFailed, setForwardingFailed] = useState(false);
    const [forwardingFailedReason, setForwardingFailedReason] = useState(undefined);
    const [lastPlacementId, setLastPlacementId] = useState(undefined);
    const [lastGraphItemId, setLastGraphItemId] = useState(undefined);
    const filteredSubLOBOptions = optionsSubLOB.filter(sub => sub.parentKey === selectedLOB);
    const [lastSharedMailbox, setLastSharedMailbox] = useState(undefined);
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const [emailSubject, setEmailSubject] = useState("");
    const [isDraftEmail, setIsDraftEmail] = useState(false);
    const [isDuplicate, setIsDuplicate] = useState(false);
    const [fileValidationResult, setFileValidationResult] = useState({ isValid: true, errors: [] });
    const [isValidatingFiles, setIsValidatingFiles] = useState(false);
    const [isUpdateMode, setIsUpdateMode] = React.useState(false);
    useEffect(() => {
        try {
            const savedLOB = localStorage.getItem("wb.selectedLOB");
            const savedSubLOB = localStorage.getItem("wb.selectedSubLOB");
            const savedBU = localStorage.getItem("wb.selectedBU");
            const savedCopy = localStorage.getItem("wb.sendCopyToCyberAdmin");
            if (savedLOB)
                setSelectedLOB(savedLOB);
            if (savedSubLOB)
                setSelectedSubLOB(savedSubLOB);
            if (savedBU)
                setSelectedBU(savedBU);
            if (savedCopy !== null)
                setSendCopyToCyberAdmin(savedCopy === "true");
        }
        catch (_a) { }
    }, []);
    // useEffect(() => {
    //   try {
    //     const savedProduct = window.localStorage.getItem("wb.selectedProduct");
    //     const savedBU = window.localStorage.getItem("wb.selectedBU");
    //     const savedCopy = window.localStorage.getItem("wb.sendCopyToCyberAdmin");
    //     if (savedProduct) {
    //       setSelectedProduct(savedProduct);
    //     }
    //     if (savedBU) {
    //       setSelectedBU(savedBU);
    //     }
    //     if (savedCopy !== null) {
    //       setSendCopyToCyberAdmin(savedCopy === "true");
    //     }
    //   } catch { }
    // }, []);
    // useEffect(() => {
    //   try {
    //     window.localStorage.setItem("wb.selectedProduct", selectedProduct);
    //   } catch { }
    // }, [selectedProduct]);
    // useEffect(() => {
    //   try {
    //     window.localStorage.setItem("wb.selectedBU", selectedBU);
    //   } catch { }
    // }, [selectedBU]);
    useEffect(() => {
        localStorage.setItem("wb.selectedLOB", selectedLOB);
    }, [selectedLOB]);
    useEffect(() => {
        localStorage.setItem("wb.selectedSubLOB", selectedSubLOB);
    }, [selectedSubLOB]);
    useEffect(() => {
        localStorage.setItem("wb.selectedBU", selectedBU);
    }, [selectedBU]);
    useEffect(() => {
        try {
            window.localStorage.setItem("wb.sendCopyToCyberAdmin", String(sendCopyToCyberAdmin));
        }
        catch (_a) { }
    }, [sendCopyToCyberAdmin]);
    const handleLOBChange = (_e, option) => {
        const selectedlob = option === null || option === void 0 ? void 0 : option.key;
        let selectedBU = "MRSNA";
        if (selectedlob === "106000" || selectedlob === "110000") {
            selectedBU = "MRSGM";
        }
        setSelectedLOB(selectedlob);
        // Find Sub‑LOBs matching this LOB
        const matchingSubLOBs = optionsSubLOB.filter(sub => sub.parentKey === selectedlob);
        // ✅ REUSE previously selected SubLOB if it belongs to this LOB
        const previousSubLOBStillValid = matchingSubLOBs.some(sub => sub.key === selectedSubLOB);
        if (previousSubLOBStillValid) {
            // do nothing – keep existing SubLOB
            return;
        }
        // Auto‑select first Sub‑LOB if available
        if (matchingSubLOBs.length > 0) {
            setSelectedSubLOB(matchingSubLOBs[0].key);
        }
        else {
            setSelectedSubLOB("");
        }
        setSelectedBU(selectedBU);
    };
    const handleSubLOBChange = (_e, option) => {
        setSelectedSubLOB(option === null || option === void 0 ? void 0 : option.key);
    };
    useEffect(() => {
        if (!selectedLOB || selectedSubLOB)
            return;
        const matching = optionsSubLOB.filter(sub => sub.parentKey === selectedLOB);
        if (matching.length > 0) {
            setSelectedSubLOB(matching[0].key);
        }
    }, [selectedLOB]);
    const handleDownloadEmail = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield Office.onReady();
        }
        catch (err) {
            DebugService.error("Office.js failed to initialize:", err);
            setShowFailureMessage(true);
            return;
        }
        let item;
        try {
            item = Office.context.mailbox.item;
        }
        catch (err) {
            DebugService.error("Unable to access mailbox item:", err);
            setShowFailureMessage(true);
            return;
        }
        if (!item) {
            DebugService.error("No email item available");
            return;
        }
        //Check if the email already sent for Ingestion
        try {
            const isDuplicateN = yield checkDuplicateSubmission(item, DebugService);
            setIsDuplicate(isDuplicateN);
            DebugService.debug("Is duplicate Check Done");
        }
        catch (err) {
            DebugService.error("Error in Duplicate function", err);
        }
        // Check if it's a draft email and get the subject
        const isDraft = OfficeModeService.isComposeMode();
        setIsDraftEmail(isDraft);
        // Get the email subject
        try {
            const subject = yield new Promise((resolve) => {
                item.subject.getAsync((result) => {
                    if (result.status === Office.AsyncResultStatus.Succeeded) {
                        resolve(result.value || "");
                    }
                    else {
                        resolve("");
                    }
                });
            });
            setEmailSubject(subject);
        }
        catch (error) {
            DebugService.warn("Failed to get email subject:", error);
            setEmailSubject("");
        }
        // Validate email attachments
        const filesValid = yield validateEmailFiles(item);
        if (!filesValid) {
            DebugService.warn("File validation failed - showing error message");
            // Don't return here - let the UI show the error message
        }
        // Trigger early save when user first interacts with UI
        try {
            yield workbenchService.attemptEarlySave(item);
        }
        catch (error) {
            DebugService.warn("Early save failed, continuing with workflow:", error);
        }
        setShowLanding(false);
        setShowBUProducts(true);
    });
    // Adds a banner to the top of the email body
    const addBannerToEmail = () => __awaiter(void 0, void 0, void 0, function* () {
        yield Office.onReady();
        const item = Office.context.mailbox.item;
        // Check if item is a message
        if (item.itemType === Office.MailboxEnums.ItemType.Message) {
            const messageCompose = item;
            // Check if we're in compose mode by checking if prependAsync is available
            if (messageCompose.body && typeof messageCompose.body.prependAsync === 'function') {
                const bannerHtml = `<div style="padding:10px;font-weight:bold;color:#00796b;margin-bottom:10px;">Sent for Ingestion</div>`;
                return new Promise((resolve, reject) => {
                    messageCompose.body.prependAsync(bannerHtml, { coercionType: Office.CoercionType.Html }, (result) => {
                        if (result.status === Office.AsyncResultStatus.Succeeded) {
                            DebugService.debug("Banner added successfully.");
                            resolve();
                        }
                        else {
                            DebugService.error("Error adding banner:", result.error.message);
                            reject(result.error);
                        }
                    });
                });
            }
            else {
                // We're in read mode, can't add banner
                DebugService.debug("Cannot add banner in read mode - item is not in compose mode.");
                return Promise.resolve(); // Don't reject, just skip adding the banner
            }
        }
        else {
            DebugService.error("Not a message item.");
            return Promise.reject("Invalid context - not a message item.");
        }
    });
    // Cast to MessageCompose to access body
    //   const message = item as Office.MessageCompose;
    //   if (message.body && typeof message.body.prependAsync === "function") {
    //     return new Promise<void>((resolve, reject) => {
    //       const bannerHtml = `<div style="background:#e0f7fa;padding:10px;font-weight:bold;color:#00796b;border:1px solid #00796b;margin-bottom:10px;">Sent for Ingestion</div>`;
    //       try {
    //         message.body.prependAsync(
    //           bannerHtml,
    //           { coercionType: Office.CoercionType.Html },
    //           (result: Office.AsyncResult<void>) => {
    //             if (result.status === Office.AsyncResultStatus.Succeeded) {
    //               resolve();
    //               console.log("Banner added successfully")
    //             } else {
    //               reject(result.error);
    //             }
    //           }
    //         );
    //       } catch (err) {
    //         reject(err as any);
    //       }
    //     });
    //   } else {
    //     console.error("Message body is not available in this context.");
    //     return Promise.reject("Message body is not available.");
    //   }
    // };
    const handleSendCopyToggle = (_event, checked) => {
        setSendCopyToCyberAdmin(!!checked);
    };
    const handleAssignIngestionToggle = (_event, checked) => {
        setAssignIngestionToSelf(!!checked);
    };
    const validateEmailFiles = (item) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsValidatingFiles(true);
            const validationResult = yield FileValidationService.validateEmailAttachments(item);
            setFileValidationResult(validationResult);
            return validationResult.isValid;
        }
        catch (error) {
            DebugService.error('File validation failed:', error);
            setFileValidationResult({
                isValid: false,
                errors: [{
                        type: 'unsupported',
                        message: 'Unable to validate attachments. Please check file types and try again.',
                        files: []
                    }]
            });
            return false;
        }
        finally {
            setIsValidatingFiles(false);
        }
    });
    const handleSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        setShowLoadingMessage(true);
        try {
            yield Office.onReady();
            const item = Office.context.mailbox.item;
            if (!item || item.itemType !== Office.MailboxEnums.ItemType.Message) {
                setShowLoadingMessage(false);
                setShowFailureMessage(true);
                return;
            }
            // For draft emails, check if subject is empty before proceeding
            if (OfficeModeService.isComposeMode()) {
                try {
                    const currentSubject = yield new Promise((resolve) => {
                        item.subject.getAsync((result) => {
                            if (result.status === Office.AsyncResultStatus.Succeeded) {
                                resolve(result.value || "");
                            }
                            else {
                                resolve("");
                            }
                        });
                    });
                    if (!currentSubject || currentSubject.trim() === "") {
                        setShowLoadingMessage(false);
                        setShowFailureMessage(true);
                        return;
                    }
                }
                catch (error) {
                    DebugService.warn("Failed to get current email subject:", error);
                    setShowLoadingMessage(false);
                    setShowFailureMessage(true);
                    return;
                }
            }
            // Validate files before proceeding
            const filesValid = yield validateEmailFiles(item);
            if (!filesValid) {
                setShowLoadingMessage(false);
                return;
            }
            const isDuplicate = yield checkDuplicateSubmission(item, DebugService);
            DebugService.debug("Duplicate detection result:", isDuplicate);
            if (isDuplicate) {
                DebugService.debug("Duplicate detected - showing confirmation dialog");
                setShowLoadingMessage(false);
                setShowConfirmationDialog(true);
                return;
            }
            const result = yield submitPlacement(apiToken, graphToken, item, selectedLOB, selectedSubLOB, sendCopyToCyberAdmin, assignIngestionToSelf, workbenchService);
            if (result.success) {
                if (result.forwardingFailed) {
                    setShowLoadingMessage(false);
                    setShowFailureMessage(true);
                    setForwardingFailed(true);
                    setLastPlacementId(result.lastPlacementId);
                    setLastGraphItemId(result.lastGraphItemId);
                    setLastSharedMailbox(result.lastSharedMailbox);
                }
                else {
                    setShowLoadingMessage(false);
                    setShowSuccessMessage(true);
                }
            }
            else {
                setShowLoadingMessage(false);
                setShowFailureMessage(true);
            }
        }
        catch (error) {
            setShowLoadingMessage(false);
            setShowFailureMessage(true);
        }
    });
    const handleSendAgain = () => __awaiter(void 0, void 0, void 0, function* () {
        setShowConfirmationDialog(false);
        setShowLoadingMessage(true);
        try {
            const item = Office.context.mailbox.item;
            if (item) {
                const result = yield submitPlacement(apiToken, graphToken, item, selectedLOB, selectedSubLOB, sendCopyToCyberAdmin, assignIngestionToSelf, workbenchService);
                if (result.success) {
                    if (result.forwardingFailed) {
                        setShowLoadingMessage(false);
                        setShowFailureMessage(true);
                        setForwardingFailed(true);
                        setForwardingFailedReason(result.forwardingFailedReason);
                        setLastPlacementId(result.lastPlacementId);
                        setLastGraphItemId(result.lastGraphItemId);
                        setLastSharedMailbox(result.lastSharedMailbox);
                    }
                    else {
                        setShowLoadingMessage(false);
                        setShowSuccessMessage(true);
                    }
                }
                else {
                    setShowLoadingMessage(false);
                    setShowFailureMessage(true);
                }
            }
        }
        catch (error) {
            setShowLoadingMessage(false);
            setShowFailureMessage(true);
        }
    });
    const handleCancel = () => {
        setShowConfirmationDialog(false);
        setShowLanding(true);
        setShowBUProducts(false);
    };
    const handleRetryForward = () => __awaiter(void 0, void 0, void 0, function* () {
        DebugService.debug("=== Retry Forward Debug ===");
        DebugService.debug("lastPlacementId:", lastPlacementId);
        DebugService.debug("lastGraphItemId:", lastGraphItemId);
        DebugService.debug("lastSharedMailbox:", lastSharedMailbox);
        DebugService.debug("forwardingFailedReason:", forwardingFailedReason);
        DebugService.debug("=== End Retry Forward Debug ===");
        if (!lastPlacementId || !lastGraphItemId || !lastSharedMailbox) {
            DebugService.error("Missing required data for retry:", {
                lastPlacementId,
                lastGraphItemId,
                lastSharedMailbox,
            });
            return;
        }
        if (forwardingFailedReason === "DRAFT_EMAIL_NO_ITEM_ID") {
            DebugService.debug("Cannot retry forwarding for draft email - itemId not available");
            return;
        }
        setShowLoadingMessage(true);
        try {
            const result = yield workbenchService.retryForward(graphToken, lastPlacementId, lastGraphItemId, lastSharedMailbox);
            if (result.success) {
                setShowLoadingMessage(false);
                setShowSuccessMessage(true);
                setShowFailureMessage(false);
                setForwardingFailed(false);
            }
            else {
                setShowLoadingMessage(false);
                setShowFailureMessage(true);
            }
        }
        catch (error) {
            setShowLoadingMessage(false);
            setShowFailureMessage(true);
        }
    });
    const handleLandingSave = () => __awaiter(void 0, void 0, void 0, function* () {
        DebugService.debug('handleLandingSave called - starting file validation');
        // Validate email attachments when user clicks "New Placement"
        try {
            const item = Office.context.mailbox.item;
            if (item) {
                DebugService.debug('Office item found, calling validateEmailFiles');
                yield validateEmailFiles(item);
                DebugService.debug('File validation completed in handleLandingSave');
            }
            else {
                DebugService.warn('No Office item found in handleLandingSave');
            }
        }
        catch (error) {
            DebugService.error('File validation failed in handleLandingSave:', error);
        }
        setIsUpdateMode(false);
        setShowLanding(false);
        setShowBUProducts(true);
    });
    const handleBack = () => {
        // Always clear overlays
        setShowSuccessMessage(false);
        setShowFailureMessage(false);
        setShowLoadingMessage(false);
        setShowConfirmationDialog(false);
        // Go to previous logical screen
        if (showBUProducts) {
            // From BUProducts, go back to Landing
            setShowLanding(true);
            setShowBUProducts(false);
            setIsUpdateMode(false);
        }
    };
    const handleHome = () => {
        // Always clear overlays
        addBannerToEmail();
        setShowSuccessMessage(false);
        setShowFailureMessage(false);
        setShowLoadingMessage(false);
        setShowConfirmationDialog(false);
        // Go to landing screen
        setShowLanding(true);
        setShowBUProducts(false);
        // Reset navigation state
        setIsUpdateMode(false);
    };
    const handleProductChange = (_event, option) => {
        const selectedProduct = option === null || option === void 0 ? void 0 : option.key;
        let selectedBU = "MRSNA";
        if (selectedProduct === "20001" || selectedProduct === "20002") {
            selectedBU = "MRSGM";
        }
        else if (selectedProduct === "NA_LPL" || selectedProduct === "NA_MPL" || selectedProduct === "Commercial_General_Liability") {
            selectedBU = "MRSNA";
        }
        //setSelectedProduct(selectedProduct);
        setSelectedBU(selectedBU);
    };
    const handleUpdatePlacement = () => __awaiter(void 0, void 0, void 0, function* () {
        DebugService.debug("handleUpdatePlacement called - starting update flow");
        try {
            const item = Office.context.mailbox.item;
            if (item) {
                yield validateEmailFiles(item);
                DebugService.debug("File validation completed in handleUpdatePlacement");
            }
            else {
                DebugService.warn("No Office item found in handleUpdatePlacement");
            }
        }
        catch (error) {
            DebugService.error("File validation failed in handleUpdatePlacement:", error);
        }
        //setSelectedProduct("20001");
        //setSelectedLOB("106000");
        //setSelectedSubLOB("106203");
        //setSelectedBU("MRSGM");
        setIsUpdateMode(true);
        setShowLanding(false);
        setShowBUProducts(true);
    });
    const handleBUChange = (_event, option) => {
        setSelectedBU(option === null || option === void 0 ? void 0 : option.key);
    };
    // Render
    // Security check - ensure we have valid tokens
    if (!apiToken || !graphToken) {
        return (_jsx("div", { style: { padding: "16px" }, children: _jsx(MessageBar, { messageBarType: MessageBarType.error, isMultiline: true, children: "Authentication required. Please reload the add-in and sign in again." }) }));
    }
    return (_jsxs("div", { children: [_jsx(WorkbenchHeader, { onBack: handleBack, onHome: handleHome, title: "Underwriting Workbench", isDuplicate: isDuplicate }), showLoadingMessage ? (_jsx(SpinnerOverlay, { label: "Saving to workbench..." })) : showSuccessMessage ? (_jsx(SuccessMessage, { isVisible: true, onSuccess: addBannerToEmail })) : showFailureMessage ? (_jsxs("div", { children: [_jsx(ErrorMessage, { isVisible: true, onSubmit: handleSubmit }), _jsx(RetryButton, { isVisible: forwardingFailed, onRetry: handleRetryForward, reason: forwardingFailedReason, hasValidData: !!lastGraphItemId })] })) : (_jsxs(_Fragment, { children: [showLanding && _jsx(LandingSection, { onNewPlacement: handleLandingSave, onUpdatePlacement: handleUpdatePlacement }), showBUProducts && (_jsx(BUProductsSection
                    //selectedProduct={selectedProduct}
                    , { 
                        //selectedProduct={selectedProduct}
                        selectedBU: selectedBU, 
                        //optionsProducts={filteredProducts}
                        optionsBU: optionsBU, selectedLOB: selectedLOB, selectedSubLOB: selectedSubLOB, optionsLOB: optionsLOB, optionsSubLOB: filteredSubLOBOptions, onLOBChange: handleLOBChange, onSubLOBChange: handleSubLOBChange, 
                        //onProductChange={handleProductChange}
                        onBUChange: handleBUChange, sendCopyToCyberAdmin: sendCopyToCyberAdmin, assignIngestionToSelf: assignIngestionToSelf, onSendCopyToggle: handleSendCopyToggle, onAssignIngestionToggle: handleAssignIngestionToggle, onSubmit: handleSubmit, emailSubject: emailSubject, isDraftEmail: isDraftEmail, fileValidationError: FileValidationService.getAllErrorMessages(fileValidationResult.errors), isSubmitDisabled: !fileValidationResult.isValid || isValidatingFiles, isUpdateMode: isUpdateMode })), _jsx(ConfirmationDialog, { isVisible: showConfirmationDialog, onSendAgain: handleSendAgain, onCancel: handleCancel })] }))] }));
};
export default WorkbenchLanding;
